import toolBarOptsReducer from './toolBarOptsReducer';

export default toolBarOptsReducer;